import { getCategory } from '@/apis/search'
import { t } from '@/plugins/i18n'
import { useSite2Station } from '..'
import { useRoute } from 'vue-router'
import { ShopType } from '@/common/const'

const route = useRoute()

interface CateItem {
  label?: string;
  labelJP?: string;
  value?: string;
  check?: boolean;
  children?: CateItem[];
  cateNameJp: string;
  cateNameZh: string;
  productCategoryFrontendId: string;
}
interface Cate {
  channel: number;
  productCategoryFrontendShortRespDTOList: CateItem[];
}

export default {
  namespaced: true,
  state: {
    Channels: [
      { label: '我的频道', name: 'channel', value: '0' },
      {
        label: '透明购',
        name: 'pureIndex',
        value: '2',
        children: ['platform']
      },
      { label: '市场购', name: 'market', value: '1' }
      // { label: '市场购', name: 'market', value: '1' },
    ],
    Sellers: [
      { label: t('采购来源'), value: '' },
      // { label: 'CKB choice', value: 'choice', channel: '1' },
      { label: '1688', value: 'AM', channel: '2', tagImg: true },
      { label: t('淘宝'), value: 'TB', channel: '2' },
      { label: 'Tmall', value: 'TM', channel: '2' },
      { label: t('网商园'), value: 'WS', channel: '1' },
      { label: t('搜款网'), value: 'VC', channel: '1' }

    ],
    Shops: [
      { label: 'Base', value: ShopType.BASE, source: 'd2c', site: 'ja' },
      { label: 'Shopify', value: ShopType.SHOPIFY, source: 'd2c', site: 'ja,en' },
      { label: 'Tiktok', value: ShopType.TIKTOK, source: 'd2c', site: 'ja' },
      { label: 'Amazon', value: ShopType.AMAZON, source: 'b2b', site: 'ja' },
      // 未审核先隐藏
      { label: 'STORES', value: ShopType.STORE, source: 'd2c', site: 'ja' },
      // { label: 'Cafe24', value: 6, source: 'd2c', site: 'ko' },
      { label: '自建独立站', value: ShopType.SELF, source: 'd2c', site: 'ja' },
      { label: '其他', value: ShopType.OTHER }
    ],
    category: {},
    SortTypes: [
      { label: '默认顺序', bothway: false, name: '', showInImageSearch: true }, // 默认 update_time
      { label: '销量', bothway: false, name: 'product_sell_quantity', showInImageSearch: false },
      { label: '价格', bothway: true, name: 'product_sell_price', showInImageSearch: false }
    ].fort(),
    others: {
      AM: [
        {
          name: 'sort',
          label: '排序',
          value: [{ name: '', label: '', value: '' }]
        }
      ],
      TB: [],
      TM: []
    },
    // 搜索参数
    schannel: '2',
    platformType: 'AM', // 1688精选货盘需求 默认选中1688
    productCategoryFrontendId: '',
    productCategoryFrontendIdNameZh: '',
    langType: localStorage.SearchLangType
      ? '' + parseInt(localStorage.SearchLangType)
      : '1',
    keyword: '',
    sortType: '',
    descendOrder: true,
    sellPriceStart: '',
    sellPriceEnd: '',
    //
    seller: '',
    fastCates: {},
    viaCrx: true,
    promise: Promise.resolve(),
    // 外链平台检索条件
    platCondition: {
      // 排序
      sort: '',
      // 价格区间
      startPrice: null,
      endPrice: null,
      // 其他条件
      other: []
    },
    // 外链
    externalLinks: {
      TB: 'https://s.taobao.com/search?',
      TM: 'https://list.tmall.com/search_product.htm?',
      AM: 'https://s.1688.com/selloffer/offer_search.htm?',
      WS: 'https://wsy.com/search.htm?',
      VC: 'https://www.vvic.com/gz/search/index.html?'
    },
    deliverData: null
  },
  getters: {
    model (state: any): any {
      return {
        schannel: state.schannel,
        platformType: state.platformType,
        productCategoryFrontendId: state.productCategoryFrontendId,
        langType: state.langType,
        keyword: state.keyword,
        sortType: state.sortType,
        descendOrder: state.descendOrder,
        sellPriceStart: state.sellPriceStart,
        sellPriceEnd: state.sellPriceEnd
      }
    },
    getAddress (state: any) {
      return state.deliverData
    }
  },
  mutations: {
    UPDATE_SELLERS: (state: any, list: any) => {
      state.Sellers = list
    },
    RESET_CONDITION: (state: any) => {
      state.platCondition.sort = ''
      state.platCondition.startPrice = null
      state.platCondition.endPrice = null
      state.platCondition.other = []
    }
  },
  actions: {
    once ({ commit, state }: any): void {
      commit(
        'promise',
        state.promise.then(() => {
          return getCategory({
            stationCode: useSite2Station()
          }).then((res) => {
            const { data } = res
            if (data) {
              // 市场购 透明购
              data.sort((a: Cate, b: Cate) => a.channel - b.channel)
              //
              data.forEach((v: Cate) => {
                state.category[v.channel] = [
                  {
                    cateNameJp: t('类目'),
                    cateNameKr: t('类目'),
                    cateNameEn: t('类目'),
                    productCategoryFrontendId: ''
                  },
                  ...traverse(
                    v.productCategoryFrontendShortRespDTOList,
                    (v: CateItem) => {
                      v.labelJP = v.cateNameJp
                      v.label = v.cateNameJp
                      v.value = v.productCategoryFrontendId
                    }
                  )
                ]
              })
              const { fastCates } = state
              data.forEach((c: Cate, i: number) => {
                let cate = fastCates[c.channel] || []
                const v = c.productCategoryFrontendShortRespDTOList
                if (cate.length) {
                  const cateSet: Map<string, boolean> = new Map(
                    cate.map((v: CateItem) => [
                      v.productCategoryFrontendId,
                      v.check
                    ])
                  )
                  cate = v.filter((item: CateItem) => {
                    if (cateSet.has(item.productCategoryFrontendId)) {
                      item.check = cateSet.get(item.productCategoryFrontendId)
                      return v
                    }
                  })
                  const newCate = v.filter((item: CateItem) => {
                    return !cateSet.has(item.productCategoryFrontendId)
                  })
                  if (newCate.length) {
                    cate = cate.concat(newCate)
                  }
                } else {
                  let count = 0
                  cate = v.map((item: CateItem) => {
                    if (count < 8) {
                      item.check = true
                    }
                    count += 1
                    return item
                  })
                }
                fastCates[c.channel] = cate
              })
              commit('fastCates', state.fastCates)
            }
          })
        })
      )
    }
  },
  local: {
    fastCates: true,
    schannel: true,
    viaCrx: true
    // deliverData: true
  }
}

function traverse (arr: any[], callback: any, children = 'children') {
  return arr.map((v) => {
    callback(v)
    if (Array.isArray(v[children])) {
      v[children] = traverse(v[children], callback, children)
    }
    return v
  })
}

export const myShopIcons: any = {
  0: require('@/assets/image/ckbuser.png'),
  1: require('@/assets/image/shop_base.png'),
  2: require('@/assets/image/shop_shopify.png'),
  3: 'https://static-jp.theckb.com/static-asset/client/stores_logo.png',
  4: require('@/assets/image/shop_amazon.png'),
  6: require('@/assets/image/shop_cafe24.png'),
  7: require('@/assets/image/ckbuser.png'),
  11: require('@/assets/image/tiktok.png')
}
